function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select, InputNumber, Space, message, Alert } from "antd";
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var EditCompany = function EditCompany(_ref) {
  var _ref$company = _ref.company,
    company = _ref$company === void 0 ? null : _ref$company,
    handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    insurers = _useState8[0],
    setInsurers = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    rateDisabled = _useState0[0],
    setRateDisabled = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    insDisabled = _useState10[0],
    setInsDisabled = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    insuranceId = _useState12[0],
    setInsuranceId = _useState12[1];
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    rate = _useState14[0],
    setRate = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isDataChanged = _useState16[0],
    setIsDataChanged = _useState16[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onTypeChange = function onTypeChange(v) {
    setRateDisabled(v == 1);
    setInsDisabled(v == 1);
  };
  var onInsChange = function onInsChange(v) {
    setInsuranceId(v);
  };
  var onRateChange = function onRateChange(v) {
    if (v != null) setRate(v);
  };
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    var formData = new FormData();
    formData.append("id", company.id);
    formData.append('label', values.label);
    formData.append('address', values.address);
    formData.append('telephone', values.telephone);
    formData.append('insurance_id', values.insurance_id);
    formData.append('rate', rate);
    formData.append('commercial_rate', values.commercial_rate);
    formData.append('tax_rate', values.tax_rate);
    formData.append("type", values.type);
    axios.post(Common.baseApiUrl + 'editcompany', formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  useEffect(function () {
    setIsDataChanged(false);
    setIsFormLoading(true);
    axios.get(Common.baseApiUrl + 'geticompanylist/' + Common.currentUser.id).then(function (response) {
      setIsFormLoading(false);
      if (response.data.status == 200 && response.data.iclist.length > 0) {
        setInsurers(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            label: "Aucune",
            value: 0
          }]);
        });
        response.data.iclist.forEach(function (ic) {
          setInsurers(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: ic.label,
              value: ic.id
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    });
    form.setFieldsValue({
      company_id: company.company_id,
      rate: company.rate,
      address: company.address,
      telephone: company.telephone,
      type: company.type,
      commercial_rate: company.commercial_rate,
      tax_rate: company.tax_rate,
      label: company.label
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [formError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: formError,
      showIcon: true
    }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: formSuccess,
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "type",
        label: "Cat\xE9gorie",
        rules: [{
          required: true,
          message: "Veuillez choisir un type"
        }],
        children: /*#__PURE__*/_jsx(Select, {
          onChange: onTypeChange,
          defaultValue: [0],
          options: [{
            label: "SOCIETE",
            value: 0
          }, {
            label: "ASSURANCE",
            value: 1
          }],
          placeholder: "Choisir un type"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "label",
        label: "Nom",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "address",
        label: "Adresse",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "telephone",
        label: "T\xE9l\xE9phone",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(Form.Item, {
          name: "insurance_id",
          onChange: onInsChange,
          label: "Assurance",
          children: /*#__PURE__*/_jsx(Select, {
            defaultActiveFirstOption: true,
            disabled: insDisabled,
            options: insurers,
            placeholder: "Choisir l'assureur"
          })
        }), /*#__PURE__*/_jsx(Form.Item, {
          name: "rate",
          label: "Taux (%)",
          children: /*#__PURE__*/_jsx(InputNumber, {
            onChange: onRateChange,
            disabled: rateDisabled
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "commercial_rate",
        label: "Taux commercial",
        rules: [{
          required: true,
          message: "Veuillez choisir un taux"
        }],
        children: /*#__PURE__*/_jsx(Select, {
          defaultValue: [0],
          options: [{
            label: "0 %",
            value: 0
          }, {
            label: "-5 %",
            value: -5
          }, {
            label: "-10 %",
            value: -10
          }, {
            label: "-20 %",
            value: -20
          }, {
            label: "-30 %",
            value: -30
          }, {
            label: "-40 %",
            value: -40
          }, {
            label: "-50 %",
            value: -50
          }, {
            label: "-60 %",
            value: -60
          }, {
            label: "-70 %",
            value: -70
          }, {
            label: "-80 %",
            value: -80
          }, {
            label: "-90 %",
            value: -90
          }, {
            label: "+10 %",
            value: 10
          }, {
            label: "+50 %",
            value: 50
          }, {
            label: "+100 %",
            value: 100
          }, {
            label: "+150 %",
            value: 150
          }]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "tax_rate",
        label: "Taxe retenue",
        rules: [{
          required: true,
          message: "Taxes & Retenue"
        }],
        children: /*#__PURE__*/_jsx(Select, {
          defaultValue: [0],
          options: [{
            label: "0 %",
            value: 0
          }, {
            label: "5 %",
            value: 5
          }, {
            label: "10 %",
            value: 10
          }]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          htmlType: "submit",
          loading: isFormLoading,
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "MODIFIER"
          })
        })
      })]
    })]
  });
};
export default EditCompany;